module.exports = __webpack_public_path__ + "img/cwm-logo-en@legacy.4e96b290.svg";